import * as grs from 'grs'

export const getTransactionStatuses = () => {
    switch (window.COUNTRY_PURCHASE_FLOW) {
        case 'BR':
            return [grs.constants.STATUS_ACTIVE, grs.constants.STATUS_PASSED, grs.constants.STATUS_CANCELLED]
        default:
            return [
                grs.constants.STATUS_ACTIVE,
                grs.constants.STATUS_PASSED,
                grs.constants.STATUS_CANCELLED,
                grs.constants.STATUS_WAITING_LIST,
            ]
    }
}
